<template>
    <div>
        <form-container :disabled="loading" :header="translate('settings.accountParams')" @save="save">
            <template v-slot:tabs>
                <tab :tabs="availableTabs" :bullets="false" v-model="tab" ref="tabs"></tab>
            </template>
            <div v-show="tab == 'genel'"  class="row">
                <div class="col">
                    <div class="form-group row">
                        <label for="inputTitle" class="col-sm-2 col-form-label">{{translate('accountParams.accountName')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" required maxlength="100" v-model="data.Title" id="inputTitle">
                        </div>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsMinSignerCountActive" id="MinSignerCountActive">
                        <label for="MinSignerCountActive" class="form-check-label">
                            {{translate('accountParams.toCirculateJob')}} <input v-model="data.Params.MinSignerCount" min="1" :disabled="!data.Params.IsMinSignerCountActive" required class="line-input" style="width:50px; text-align:center;" type="number"/> {{translate('accountParams.shouldBeSigner')}}
                        </label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsIdentityNumberRequiredForExternalSigner" id="IsIdentityNumberRequiredForExternalSigner">
                        <label class="form-check-label" for="IsIdentityNumberRequiredForExternalSigner">{{translate('accountParams.identityNumberRequiredForExternalSigner')}}</label>
                    </div>
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsIdentityNumberRequiredForInternalUser" id="IsIdentityNumberRequiredForInternalUser">
                        <label class="form-check-label" for="IsIdentityNumberRequiredForInternalUser">{{translate('accountParams.identityNumberRequiredForInternalUser')}}</label>
                        <small class="d-block text-muted">{{translate('accountParams.identityNumberRequiredForInternalUserText')}}</small> 
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.VerifyIdentityDataFromGovService" id="VerifyIdentityDataFromGovService">
                        <label class="form-check-label" for="VerifyIdentityDataFromGovService">{{translate('accountParams.verifyIdentityDataFromGovService')}}</label>
                        <small class="d-block text-muted">{{translate('accountParams.verifyIdentityDataFromGovServiceText')}}</small> 
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.AmountRequiredForBankOrder" id="AmountRequiredForBankOrder">
                        <label class="form-check-label" for="AmountRequiredForBankOrder">{{translate('accountParams.amountRequiredForBankOrder')}}</label>
                    </div>
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.AmountRequiredForContract" id="AmountRequiredForContract">
                        <label class="form-check-label" for="AmountRequiredForContract">{{translate('accountParams.amountRequiredForContract')}}</label>
                    </div>
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.CloseOtherSessionsOnLogin" id="CloseOtherSessionsOnLogin">
                        <label class="form-check-label" for="CloseOtherSessionsOnLogin">{{translate('accountParams.closeOtherSessionsOnLogin')}}</label>
                    </div>
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsSameUserCanSignMultipleTimes" id="IsSameUserCanSignMultipleTimes">
                        <label class="form-check-label" for="IsSameUserCanSignMultipleTimes">{{translate('accountParams.canSameUserSignMultipleTimes')}}</label>
                    </div>
                    
                    <div v-if="this.isOnPrem" class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsMultiFactorAuthEnabled" id="IsMultiFactorAuthEnabled">
                        <label class="form-check-label" for="IsMultiFactorAuthEnabled">{{translate('accountParams.isMultiFactorAuthEnabled')}}</label>
                    </div>
					
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsMultiFactorAuthRequiredForExternalUsers" id="IsMultiFactorAuthRequiredForExternalUsers">
                        <label class="form-check-label" for="IsMultiFactorAuthRequiredForExternalUsers">{{translate('accountParams.isMultiFactorAuthRequiredForExternalUsers')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsDownloadableVisibleDocuments" id="IsDownloadableVisibleDocuments">
                        <label class="form-check-label" for="IsDownloadableVisibleDocuments">{{translate('accountParams.isDownloadableVisibleDocuments')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.SendOTPForApprovers" id="SendOTPForApprovers">
                        <label class="form-check-label" for="SendOTPForApprovers">{{translate('accountParams.sendOTPForApprovers')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsSameUserCanSignOneTime" id="IsSameUserCanSignOneTime">
                        <label class="form-check-label" for="IsSameUserCanSignOneTime">{{translate('accountParams.canSameUserSignOneTime')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.EnablePdfDefaultSignerLocation" id="EnablePdfDefaultSignerLocation">
                        <label class="form-check-label" for="EnablePdfDefaultSignerLocation">{{translate('accountParams.enablePdfDefaultSignerLocation')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.EnableOnlineView" id="EnableOnlineView">
                        <label class="form-check-label" for="EnableOnlineView">{{translate('accountParams.enableOnlineView')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.EypOnlyPdf" id="EypOnlyPdf">
                        <label class="form-check-label" for="EypOnlyPdf">{{translate('accountParams.eypOnlyPdf')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.EnableLongVersionVisibleSignature" id="EnableLongVersionVisibleSignature">
                        <label class="form-check-label" for="EnableLongVersionVisibleSignature">{{translate('accountParams.enableLongVersionVisibleSignature')}}</label>
                    </div>

                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.EnableBankOrderPage" id="EnableBankOrderPage">
                        <label class="form-check-label" for="EnableBankOrderPage">{{translate('accountParams.enableBankOrderPage')}}</label>
                    </div>

                    <div class="form-group">
                        <label for="SendAttachmentsToTargetSystems">{{translate('accountParams.sendAttachmentsToTargetSystems')}} &nbsp;</label>
                        <select name="" id="SendAttachmentsToTargetSystems" class="line-input" v-model="data.Params.SendAttachmentsToTargetSystems" style="margin-left:8px;">
                            <option value="Never">{{translate('accountParams.never')}}</option>
                            <option value="OptionalDefaultYes">{{translate('accountParams.optionalDefaultYes')}}</option>
                            <option value="OptionalDefaultNo">{{translate('accountParams.optionalDefaultNo')}}</option>
                            <option value="Always">{{translate('accountParams.always')}}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="PdfDefaultPage">{{translate('accountParams.pdfDefaultPage')}}</label>
                        <select name="" id="PdfDefaultPage" class="line-input" v-model="data.Params.PdfDefaultPage" style="margin-left:8px;">
                            <option value="FirstPage">{{translate('accountParams.firstPage')}}</option>
                            <option value="LastPage">{{translate('accountParams.lastPage')}}</option>
                        </select>
                    </div>

                    <div class="form-group row">
                        <label for="inputTitle" class="col-sm-2 col-form-label">{{translate('accountParams.defaultDateFormat')}}</label>
                        <div class="col-sm-4 col-xs-4">
                        <!-- <input type="text" class="form-control" required maxlength="20" v-model="data.Params.DefaultDateFormat" id="DefaultDateFormat"> -->
                        
                        <select name="DefaultDateFormat" id="DefaultDateFormat" class="custom-select" v-model="data.Params.DefaultDateLocale">
                            <option value="tr" selected="selected">{{translate('accountParams.turkish')}}</option>
                            <option value="en-US">{{translate('accountParams.english')}}</option>
                        </select>
                        </div>
                        <div class="col-sm-4">
                            <date-input class="form-control" :value="new Date()" :locale="data.Params.DefaultDateLocale" />
                        </div>
                    </div>
                    
                    <div class="form-group row">                        
                        <label for="inputTargetSystemEmailDomainFilter" class="col-sm-2 col-form-label">{{translate('accountParams.targetSystemEmailDomainFilter')}}</label>
                        <div class="col-sm-8">
                        <input type="text" class="form-control" maxlength="255" v-model="data.Params.TargetSystemEmailDomainFilter" id="TargetSystemEmailDomainFilter">
                        <small class="d-block text-muted">{{translate('accountParams.targetSystemEmailDomainFilterText')}}</small> 
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="isOnPrem"  v-show="tab == 'smtp'"  class="row">
                <div class="col">
                    <div class="form-group row">                        
                        <label for="inputHost" class="col-sm-2 col-form-label">{{translate('incomingDoc.host')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" required maxlength="100" v-model="data.MailSetting.Host" id="MailSetting.Host">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">Port</label>
                        <div class="col-sm-10">
                        <input type="number" class="form-control" required maxlength="10" aria-valuemin="1" aria-valuemax="999999" value="0" v-model="data.MailSetting.Port" id="MailSetting.Port">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('incomingDoc.username')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.MailSetting.Username" id="MailSetting.Username">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('incomingDoc.password')}}</label>
                        <div class="col-sm-10">
                        <password v-model="data.MailSetting.Password" class="form-control" @change="$forceUpdate()" id="MailSetting.Password" />
                        </div>
                    </div>

                    <div class="form-group row" v-if="data.MailSetting.IsPasswordServiceActive">
                        <label for="inputPort" class="col-sm-2 col-form-label"></label>
                        <div class="col-sm-10">
                            <div class="alert alert-primary d-flex align-items-center" role="alert">
                                <iconInfoCircleFill class="bi flex-shrink-0 mr-2" width="24" height="24" viewBox="0 0 16 16" role="img" aria-label="Info:"/>
                                
                                <div>
                                    {{translate('accountParams.passwordService')}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('remPreview.sender')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.MailSetting.From" id="MailSetting.From">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('accountParams.deliveryMethod')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" readonly maxlength="100" v-model="data.MailSetting.DeliveryMethod" id="MailSetting.DeliveryMethod">
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-10">

                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" v-model="data.MailSetting.EnableSsl" id="MailSetting.EnableSsl">
                                <label class="form-check-label" for="MailSetting.EnableSsl">{{translate('incomingDoc.sslEnabled')}}</label>
                            </div>   

                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" v-model="data.MailSetting.UseDefaultCredentials" id="MailSetting.UseDefaultCredentials">
                                <label class="form-check-label" for="MailSetting.UseDefaultCredentials">{{translate('accountParams.useDefaultCredentials')}}</label>
                            </div>

                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" v-model="data.MailSetting.IsActive" id="MailSetting.IsActive">
                                <label class="form-check-label" for="MailSetting.IsActive">{{translate('targetSystemImport.active')}} - <small class="text-muted">{{translate('accountParams.allowSMTPText')}}</small></label>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="isOnPrem" v-show="tab == 'timestamp'"  class="row">
                <div class="col">
                    <div class="form-group row">                        
                        <label for="inputHost" class="col-sm-2 col-form-label">{{translate('incomingDoc.host')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.TimeStampSetting.Host" id="TimeStampSetting.Host">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('login.user')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.TimeStampSetting.User" id="TimeStampSetting.User">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('incomingDoc.password')}}</label>
                        <div class="col-sm-10">
                        <password v-model="data.TimeStampSetting.Password" class="form-control" @change="$forceUpdate()" id="TimeStampSetting.Password" />                        
                        </div>
                    </div>

                    <div class="form-group row" v-if="data.TimeStampSetting.IsPasswordServiceActive">
                        <label for="inputPort" class="col-sm-2 col-form-label"></label>
                        <div class="col-sm-10">
                            <div class="alert alert-primary d-flex align-items-center" role="alert">
                                <iconInfoCircleFill class="bi flex-shrink-0 mr-2" width="24" height="24" viewBox="0 0 16 16" role="img" aria-label="Info:"/>
                                
                                <div>
                                    {{translate('accountParams.passwordService')}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">Digest Alg.</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="10" v-model="data.TimeStampSetting.DigestAlg" id="TimeStampSetting.DigestAlg">
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-10">                            
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" v-model="data.TimeStampSetting.IsActive" id="TimeStampSetting.IsActive">
                                <label class="form-check-label" for="TimeStampSetting.IsActive">{{translate('targetSystemImport.active')}} - <small class="text-muted">{{translate('accountParams.allowTimestampText')}}</small></label>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-show="tab == 'eip'"  class="row">
                <div class="col">
                    <div v-if="isOnPrem" >
                        <h3>LDAP</h3>
                        <div class="form-group row">                        
                            <label for="inputHost" class="col-sm-2 col-form-label">Domain</label>
                            <div class="col-sm-10">
                            <input type="text" class="form-control" maxlength="100" v-model="data.LDAPSetting.Domain" id="LDAPSetting.Host">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="inputPort" class="col-sm-2 col-form-label">{{translate('login.user')}}</label>
                            <div class="col-sm-10">
                            <input type="text" class="form-control" maxlength="100" v-model="data.LDAPSetting.User" id="LDAPSetting.User">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="inputPort" class="col-sm-2 col-form-label">{{translate('incomingDoc.password')}}</label>
                            <div class="col-sm-10">
                            <password v-model="data.LDAPSetting.Password" class="form-control" @change="$forceUpdate()" id="LDAPSetting.Password" />
                            </div>
                        </div>

                        <div class="form-group row" v-if="data.LDAPSetting.IsPasswordServiceActive">
                            <label for="inputPort" class="col-sm-2 col-form-label"></label>
                            <div class="col-sm-10">
                                <div class="alert alert-primary d-flex align-items-center" role="alert">
                                    <iconInfoCircleFill class="bi flex-shrink-0 mr-2" width="24" height="24" viewBox="0 0 16 16" role="img" aria-label="Info:"/>
                                    
                                    <div>
                                        {{translate('accountParams.passwordService')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="inputPort" class="col-sm-2 col-form-label">{{translate('accountParams.syncFrequency')}}</label>
                            <div class="col-sm-5">
                                <input type="number" class="form-control" required maxlength="100" v-model.number="data.LDAPSetting.SyncInterval" id="LDAPSetting.SyncInterval" aria-valuemin="1" aria-valuemax="100" >
                            </div>
                            <div class="col-sm-5">
                                <a href="#" class="btn btn-outline-secondary" v-on:click="manuelLDAPSyncNow()">{{translate('accountParams.syncNow')}}</a>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-2"></div>
                            <div class="col-sm-10">                            
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input" v-model="data.LDAPSetting.IsActive" id="LDAPSetting.IsActive">
                                    <label class="form-check-label" for="LDAPSetting.IsActive">{{translate('targetSystemImport.active')}} - <small class="text-muted">{{translate('accountParams.activeDirectoryText')}}</small></label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3>OpenID Connect</h3>
                        <div v-if="data.ExternalAccounts && visibleExternalAccounts.length > 0">
                            <div class="row" style="padding: 10px;">
                                <div class="col-md-4" v-for="extAccount in visibleExternalAccounts" :key="extAccount.ExternalIdentitySource">
                                    <div v-bind:class="[extAccount.IsActive ? 'border-success ' : 'border-danger text-danger ', 'card mb-3']" >
                                        <div class="card-header">{{extAccount.ExternalIdentitySource}}</div>
                                        <div class="card-body ">
                                            <h5 class="card-title">{{extAccount.IsActive == true ? translate('targetSystemImport.active') : translate('accountParams.passive')}}</h5>
                                            <p class="card-text">{{translate('accountParams.externalId')}}:</p>
                                            <p> {{extAccount.ExternalId}}</p>
                                        </div>  
                                    </div>                
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-warning" role="alert" style="margin: 10px;">
                                {{translate('accountParams.externalIdText')}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            
            <div v-if="isMultiFactorAuthEnabled" v-show="tab == 'otp'"  class="row">
                <div class="col">
                    <div class="form-group row">                        
                        <label for="inputHost" class="col-sm-2 col-form-label"> {{translate('accountParams.otpProvider')}}</label>
                        <div class="col-sm-4">
                            <select id="OTPSetting.OTPHandlerSource" class="form-control" v-model="data.OTPSetting.OTPHandlerSource">
                                <option v-for="item in data.OTPSetting.OTPSources" :value="item.Value" :key="item.Key">
                                {{ item.Value }}
                                </option>
                            </select>
                        </div>

                        <div v-if="data.OTPSetting.OTPHandlerSource == 'Sms' " class="col-sm-4">
                            <select class="form-control" v-model="data.OTPSetting.SMSHandlerSource">
                                <option v-for="item in data.OTPSetting.SMSSources" :value="item.Value" :key="item.Key">
                                {{ item.Value }}
                                </option>
                            </select>
                        </div>

                    </div>


                    <div class="form-group row">                        
                        <label for="inputHost" class="col-sm-2 col-form-label">{{translate('accountParams.customerNo')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.OTPSetting.CustomerNo" id="OTPSetting.CustomerNo">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('login.user')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="100" v-model="data.OTPSetting.Username" id="OTPSetting.Username">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('incomingDoc.password')}}</label>
                        <div class="col-sm-10">
                        <password v-model="data.OTPSetting.Password" class="form-control" @change="$forceUpdate()" id="OTPSetting.Password" />                        
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">{{translate('accountParams.senderName')}}</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="20" v-model="data.OTPSetting.SenderName" id="OTPSetting.SenderName">
                        </div>
                    </div>
                    
                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">Post URL</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="500" v-model="data.OTPSetting.PostURL" id="OTPSetting.PostURL">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPort" class="col-sm-2 col-form-label">Validate URL</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" maxlength="500" v-model="data.OTPSetting.ValidateURL" id="OTPSetting.ValidateURL">
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-10">                            
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" v-model="data.OTPSetting.IsActive" id="OTPSetting.IsActive">
                                <label class="form-check-label" for="OTPSetting.IsActive">{{translate('targetSystemImport.active')}} - <small class="text-muted">{{translate('accountParams.smsText')}}</small></label>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div   v-show="tab == 'uets'"  class="row" v-if="isUETSAvailable">
                <div class="col-12" v-if="!currentTariff">
                    <div class="col-6" v-if="showUetsPanel">
                        <div class="form-group row" >                        
                            <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('ozne.tuzelSahis.mersisNo')}}</label>
                            <div class="col-sm-6">
                                <input v-model="additional.MersisNo" :disabled=!data name="MersisNo" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">                        
                            <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('ozne.kurumKurulus.detsisNo')}}</label>
                            <div class="col-sm-6">
                                <input v-model="additional.DetsisNo" name="DetsisNo" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">                        
                            <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('accountParams.taxNo')}}</label>
                            <div class="col-sm-6">
                                <input v-model="additional.GibNo" name="VergiNo" type="text" class="form-control"  />
                            </div>
                        </div>
                        <div class="form-group row">                        
                            <!-- Ödeme Türü -->
                            <label for="PaymentType" class="col-sm-4 col-form-label"></label>
                            <div class="col-sm-6 d-flex justify-content-between">
                                <button type="button" class="btn btn-success" v-if="!currentTariff" @click="firstBuyButtonClicked">{{translate('accountParams.buyTariff')}}</button>                            
                            </div>
                        </div>
                        <!-- <div class="form-group row" >
                            <div class="col-6 ">
                                <select id="PaymentType" class="form-control" v-model="uetsAccountForm.PaymentType">
                                    <option value=0>İlk Alım</option>              
                                    <option value=1>Yenileme</option>
                                    <option value=2>Tarife Değişikliği</option>              
                                </select>
                            </div>
                            
                        </div> -->
                    </div>
                </div>
                <div class="col-12" v-if="hasWaitingProcess">
                        <div class="alert alert-warning">
                            <h5>{{translate('accountParams.hasWaitingProcess')}}</h5>
                            <p>
                                {{translate('accountParams.hasWaitingProcessText')}}
                            </p>
                            <div>
                                <h5 class="ml-3">{{translate('accountParams.processInfo')}}</h5>
                                <div class="col-sm-4 ml-3">
                                    <table class="table table-sm table-borderless">
                                        <tbody>
                                            <tr>
                                                <td>{{translate('filePreview.oznePreview.name')}}</td>
                                                <td>:</td>
                                                <td>{{waitingProcess.name}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('paymentModal.price')}}</td>
                                                <td>:</td>
                                                <td>{{waitingProcess.price}} ₺</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.time')}}</td>
                                                <td>:</td>
                                                <td>{{waitingProcess.years}} {{translate('accountParams.year')}}.</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.renewalFrequency')}}</td>
                                                <td>:</td>
                                                <td>{{waitingProcess.frequency}} {{translate('accountParams.minute')}}.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <button type="button" class="btn btn-primary col-sm-2 ml-3" @click="cancelWaitingProcess" :disabled="waitingButton">{{translate('accountParams.cancelProcess')}}</button>

                                <p class="col" v-if="waitingButton">
                                    ({{translate('accountParams.waitingButtonText')}})
                                </p>
                            </div>
                        </div>
                    </div>
                <div class="col-12" v-else-if="paymentFailed">
                    <div class="col">
                        <div class="alert alert-warning">
                            <h5>{{translate('accountParams.paymentFailed')}}</h5>
                            <p>
                                {{translate('accountParams.paymentFailedText')}}
                            </p>
                            <button type="button" class="btn btn-primary" @click="cancelWaitingProcess">{{translate('accountParams.startAgain')}}</button>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-else-if="payment_Success">
                    <div class="col">
                        <div class="alert alert-warning">
                            <h5>{{translate('accountParams.paymentSuccess')}}</h5>
                            <p>
                                {{translate('accountParams.paymentSuccessText')}}
                            </p>
                            <button type="button" class="btn btn-primary" @click="uetsPortalRedirect">{{translate('accountParams.uetsPortal')}}</button>
                        </div>
                    </div>
                </div>
                <div class="col-6" v-else-if="currentTariff">
                    <div class="form-group row">                        
                        <label for="uetsPriceResponse" class="col-sm-4 col-form-label">{{translate('accountParams.currentTariff')}}</label>
                        <div class="col-sm-6">
                            <input v-model="currentTariff.Tariff.name" name="uetsPriceResponse.name" type="text" class="form-control"  readonly />
                            <!-- <select id="uetsPriceResponse" class="form-control" v-model="uetsAccountForm.uetsPriceResponse.Id" @change="uetsSelectionChanged(uetsAccountForm)">
                                <option v-for="item in uetsAccountForm.uetsPriceResponse" :value="item.Id" :key="item.Id">
                                {{ item.name }}
                                </option>
                            </select> -->
                        </div>
                    </div>
                    <div class="form-group row" >                        
                        <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('ozne.tuzelSahis.mersisNo')}}</label>
                        <div class="col-sm-6">
                            <input v-model="currentTariff.MersisNo" :disabled=!data name="MersisNo" type="text" class="form-control" readonly />
                        </div>
                    </div>
                    <div class="form-group row">                        
                        <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('ozne.kurumKurulus.detsisNo')}}</label>
                        <div class="col-sm-6">
                            <input v-model="currentTariff.DetsisNo" name="DetsisNo" type="text" class="form-control" readonly />
                        </div>
                    </div>
                    <div class="form-group row">                        
                        <label for="kimlikNo" class="col-sm-4 col-form-label">{{translate('accountParams.taxNo')}}</label>
                        <div class="col-sm-6">
                            <input v-model="currentTariff.GibNo" name="VergiNo" type="text" class="form-control" readonly />
                        </div>
                    </div>
                    <div class="form-group row">                        
                        <!-- Ödeme Türü -->
                        <label for="PaymentType" class="col-sm-4 col-form-label"></label>
                        <div class="col-sm-6 d-flex justify-content-between">
                            <button type="button" class="btn btn-success" v-if="!currentTariff" @click="firstBuyButtonClicked">{{translate('accountParams.firstBuy')}}</button>
                            <!-- TODO data yeri düzeltilecek -->
                            <button type="button" class="btn btn-primary" @click="isRenewalModalVisible=true" v-if="currentTariff">{{translate('accountParams.renewTariff')}}</button>
                            <button type="button" class="btn btn-primary" @click="isAdditionalRenewalModalVisible = true" v-if="currentTariff">{{translate('accountParams.changeTariff')}}</button>
                            
                        </div>
                    </div>
                    <!-- <div class="form-group row" >
                        <div class="col-6 ">
                            <select id="PaymentType" class="form-control" v-model="uetsAccountForm.PaymentType">
                                <option value=0>İlk Alım</option>              
                                <option value=1>Yenileme</option>
                                <option value=2>Tarife Değişikliği</option>              
                            </select>
                        </div>
                        
                    </div> -->
                </div>
                
                <div v-if="currentTariff && (!hasWaitingProcess && !payment_Success && !paymentFailed)" class="col-6" style="padding-left: 0;">
                    <div class="col invoice-table">
                        <div class="row mb-2 ml-1 mt-2"><b class="col-sm-12">{{translate('accountParams.tariffInfo')}}</b></div>
                        <div class="col-sm-12">
                            <table class="table table-sm table-borderless">
                                <tbody>
                                    <tr>
                                        <td>{{translate('filePreview.oznePreview.name')}}</td>
                                        <td>:</td>
                                        <td>{{currentTariff.Tariff.name}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('paymentModal.price')}}</td>
                                        <td>:</td>
                                        <td>{{currentTariff.Tariff.price}} ₺</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('accountParams.time')}}</td>
                                        <td>:</td>
                                        <td>{{currentTariff.Tariff.years}} {{translate('accountParams.year')}}.</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('accountParams.renewalFrequency')}}</td>
                                        <td>:</td>
                                        <td>{{currentTariff.Tariff.frequency}} {{translate('accountParams.minute')}}.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>                   
                </div>
            </div>
            <!-- Yenileme Modal -->
            <div v-if="isRenewalModalVisible" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{translate('accountParams.tariffRenewal')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="isRenewalModalVisible=false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="currentTariff">
                            <div class="form-group row">
                                <label class="col col-form-label">{{translate('accountParams.tariffRenewalText')}}</label>
                            </div>
                            <div class="form-group row">
                                <div class="col-8">
                                    <table class="table table-borderless table-sm">
                                        <tbody>
                                            <tr>
                                                <td>{{translate('filePreview.oznePreview.name')}}</td>
                                                <td>:</td>
                                                <td>{{currentTariff.Tariff.name}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('paymentModal.price')}}</td>
                                                <td>:</td>
                                                <td>{{currentTariff.Tariff.price}} ₺</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.time')}}</td>
                                                <td>:</td>
                                                <td>{{currentTariff.Tariff.years}} {{translate('accountParams.year')}}.</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.renewalFrequency')}}</td>
                                                <td>:</td>
                                                <td>{{currentTariff.Tariff.frequency}} {{translate('accountParams.minute')}}.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer footer-button-container">
                            <button type="button" class="btn btn-outline-secondary" @click="closeRenewalModal()">{{translate('close')}}</button>
                            <!-- <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.mobileSign.cancel()" data-dismiss="modal">İptal</button> -->
                            <button type="button" @click="renewalButtonClicked" class="btn btn-success" style="width:140px;" >{{translate('accountParams.renewTariff')}}</button>
                            <!-- @click="$refs.mobileSign.sign()" tarifeyi yenile butonu ödeme yap modalını açacak -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Yenileme Modal Sonu -->
            <!-- Tarife Değişikliği Modal -->
            <div v-if="isAdditionalRenewalModalVisible" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 v-if="paymentTypeFirstTime" class="modal-title">{{translate('accountParams.tariffBuying')}}</h5>
                            <h5 v-else class="modal-title">{{translate('accountParams.tariffChanging')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="isAdditionalRenewalModalVisible=false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group row">                        
                                <label for="uetsPriceResponse" class="col-sm-2 col-form-label">{{translate('accountParams.tariffs')}}</label>
                                <div class="col-sm-4">
                                    <select id="uetsPriceResponse" class="form-control" v-model="selectedTariffList">
                                        <option v-for="item in uetsPriceList.UetsPriceList" :value="item" :key="item.id">
                                        {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-8" v-if="selectedTariffList">
                                    <table class="table table-borderless table-sm">
                                        <tbody>
                                            <tr>
                                                <td>{{translate('filePreview.oznePreview.name')}}</td>
                                                <td>:</td>
                                                <td>{{selectedTariffList.name}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('paymentModal.price')}}</td>
                                                <td>:</td>
                                                <td>{{selectedTariffList.price}} ₺</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.time')}}</td>
                                                <td>:</td>
                                                <td>{{selectedTariffList.years}} {{translate('accountParams.year')}}.</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('accountParams.renewalFrequency')}}</td>
                                                <td>:</td>
                                                <td>{{selectedTariffList.frequency}} {{translate('accountParams.minute')}}.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer footer-button-container">
                            <button type="button" class="btn btn-outline-secondary" @click="closeAdditionalRenewalModal">{{translate('close')}}</button>
                            <!-- <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.mobileSign.cancel()" data-dismiss="modal">İptal</button> -->
                            <button type="button" v-if="paymentTypeFirstTime" @click="changeAdditionalClicked(selectedTariffList)" class="btn btn-success" style="width:140px;" >{{translate('accountParams.saveTariff')}}</button>
                            <button type="button" v-else @click="changeAdditionalRenewalClicked(selectedTariffList)" class="btn btn-success" style="width:140px;" >{{translate('accountParams.changeTariff')}}</button>
                            <!-- @click="$refs.mobileSign.sign()" tarifeyi yenile butonu ödeme yap modalını açacak -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tarife Değişikliği Modal Sonu -->
            <!-- Payment Template -->
            <template v-if="paymentTemplateVisible && tab == 'uets'">
                <form :disabled="loading" class="row">
                    <div class="col-sm-6" style="padding-left: 0;">
                        <div v-if="!invoiceInfo" class="col alert alert-warning">{{translate('invoiceInfo.invoiceError')}}</div>
                        <div v-else class="col invoice-table">
                            <div class="row mb-2 ml-1 mt-2"><b class="col-sm-12">{{translate('invoiceInfo.invoiceInfo')}}</b></div>
                            <div class="col-sm-12">
                                <table class="table table-sm table-borderless">
                                    <tbody>
                                        <tr>
                                            <td>{{translate('invoiceInfo.invoiceTitle')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.Name}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('draftEyp.province')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.City}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('draftEyp.district')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.District}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('invoiceInfo.taxNo')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.TaxNo}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('invoiceInfo.taxAdmin')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.TaxAdmin}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('invoiceInfo.invoiceAddress')}}</td>
                                            <td>:</td>
                                            <td>{{this.invoiceInfo.Address}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-right" style="margin-top: 20px;">
                            <button class="btn btn-outline-info" type="button" @click="invoiceInfoVisible = true">{{translate('invoiceInfo.editInvoiceInfo')}}</button>
                        </div>
                    </div>
                    <div v-if="tab == 'uets'" class="col-sm-6" style="padding-left: 0;">
                        <div v-if="invoiceInfo" class="col invoice-table">
                            <div class="row mb-2 ml-1 mt-2"><b class="col-sm-12">{{translate('accountParams.paymentInfo')}}</b></div>
                            <div class="col-sm-8">
                                <table class="table table-sm table-borderless">
                                    <tbody v-if="paymentTypeRenewal">
                                        <tr>
                                            <td>{{translate('filePreview.oznePreview.name')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.name}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('paymentModal.price')}}</td>
                                            <td>:</td>
                                            <td v-if="paymentData != null">{{paymentData.Tariff.price}} ₺</td>
                                            <td v-else>{{translate('calculating')}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.time')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.years}} {{translate('accountParams.year')}}.</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.renewalFrequency')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.frequency}} {{translate('accountParams.minute')}}.</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.endDate')}}</td>
                                            <td>:</td>
                                            <td v-if="paymentData != null">{{paymentData.ExpiressDate}}</td>
                                            <td v-else>{{translate('calculating')}}</td>
                                        </tr>
                                        
                                    </tbody>
                                    <tbody v-else-if="paymentTypeAdditionalRenewal && paymentData">
                                        <tr>
                                            <td>{{translate('paymentModal.tariffToBuy')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.name}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('paymentModal.price')}}</td>
                                            <td>:</td>
                                            <td v-if="paymentData != null">{{paymentData.Tariff.price}} ₺</td>
                                            <td v-else>{{translate('calculating')}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.time')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.years}} {{translate('accountParams.year')}}.</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.renewalFrequency')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.frequency}} {{translate('accountParams.minute')}}.</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.endDate')}}</td>
                                            <td>:</td>
                                            <td v-if="paymentData != null">{{paymentData.ExpiressDate}}</td>
                                            <td v-else>{{translate('calculating')}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="paymentTypeFirstTime && paymentData != null">
                                        <tr>
                                            <td>{{translate('paymentModal.tariffToBuy')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.name}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('paymentModal.price')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.price}} ₺</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.time')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.years}} {{translate('accountParams.year')}}.</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('accountParams.renewalFrequency')}}</td>
                                            <td>:</td>
                                            <td>{{paymentData.Tariff.frequency}} {{translate('accountParams.minute')}}.</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <span>{{translate('loading')}}</span>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-if="invoiceInfo" class="text-right" style="margin-top: 20px;">
                            <button v-if="!priceZero" class="btn btn-success" type="button" @click="makePayment" :disabled="paymentData == null"> {{translate('makePayment')}}</button>
                            <button v-else-if="priceZero" type="button" class="btn btn-primary" @click="uetsPortalRedirect">{{translate('accountParams.goToUetsPortal')}}</button>
                        </div>
                    </div>
                </form>
            </template>
            <template v-slot:footer>
                    <div class="row">
                        <div class="col text-right mlxs">
                            <button v-show="tab !== 'uets'" type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                        </div>
                    </div>
            </template>
            <payment-modal v-if="paymentModalVisible" :model="uetsAccountForm" @updateInvoiceInfo="updateInvoiceInfo" @paymentSuccess="paymentSuccess" @close="paymentModalVisible = false"></payment-modal>
            <invoice-info v-if="invoiceInfoVisible" :model="invoiceInfo" @saveInvoiceInfo="getInvoiceInfo" @close="invoiceInfoVisible = false"></invoice-info>
        </form-container>
    </div>
</template>
<script>
import axios from 'axios'
import formMixin from "../formMixin.js";
import FormContainer from '../components/FormContainer.vue';
import tab from '../components/Tab.vue';
import password from '../components/Password.vue'
import dateInput from '../components/DateInput.vue'
import InvoiceInfo from '../components/InvoiceInfo.vue';
import PaymentModal from '../components/PaymentModal.vue';

import iconInfoCircleFill from '../components/Icons/info-circle-fill.svg';

export default {
    mixins: [formMixin],
    components: {
        FormContainer,
        tab,
        password,
        dateInput,
        iconInfoCircleFill,
        InvoiceInfo,
        PaymentModal
    },
    data(){
        return {
            loading: false,
            modelName: "Account",
            data: { Params: {}, MailSetting: {}, TimeStampSetting: {}, LDAPSetting: {} , AccountId: null},
            postData: {},
            isRenewalModalVisible: false,
            invoiceInfoVisible: false,
            invoiceInfo : null,
            paymentModalVisible: false,
            paymentTemplateVisible: false,
            paymentTypeRenewal: false,
            paymentTypeFirstTime: false,
            paymentTypeAdditionalRenewal: false,
            payment_Success: false,
            isAdditionalRenewalModalVisible: false,
            uetsPriceList: null,
            uetsId: null,
            additional:{},
            currentTariff: null,
            selectedTariff: null,
            selectedTariffList: null,
            RelatedEntityId: null,
            hasWaitingProcess: false,
            waitingButton: true,
            paymentFailed: false,
            waitingProcess: null,
            showUetsPanel : true,
            paymentData: null,
            priceZero: false,
            uetsAccountForm: {
                MersisNo: "123",
                DetsisNo: "456",
                VergiNo: "789",
                PaymentType: {},
                uetsPriceResponse: [
                {
                    Id: "123",
                    name: "testName",
                    price: 12,
                    years: 10,
                    frequency: 2,
                    type: "tipTest",
                    status: "active",
                },
            ],
            },
            redirectToList: false,
            appLanguage:'tr',
            tab: 'genel',   
            tabs: [
                { key:'genel', text: this.translate('tabs.accountParamsTabs.general') },
                { key:'smtp', text: 'SMTP' },
                { key:'timestamp', text: this.translate('tabs.accountParamsTabs.timestamp') },
                { key:'eip', text:  this.translate('tabs.accountParamsTabs.eip') },
                { key:'otp', text: 'OTP' },
                { key:'uets', text: 'UETS', link: '#uets' },
            ]
        };
    },
    created(){  
        var activeTab = location.hash;
        if(activeTab == '#uets'){
            this.tab = 'uets';
            var perfEntries = performance.getEntriesByType("navigation");

            if (perfEntries[0].type === "back_forward") {
                location.reload();
            }
        }
        this.getData('')
        .then(() => {
            // this.data.Id = '';
        })
        //uets tarifeleri ve ayrıntılarını çeker
        axios.get('/uetsAppForm/getPriceList').then(x => {
            console.log("getpricelist: ", x.data)
            this.uetsPriceList = x.data;
            console.log(this.uetsPriceList)
            if(this.uetsPriceList.CurrentUetsAccount != null){
                this.uetsId = this.uetsPriceList.CurrentUetsAccount.Id
                if(this.uetsPriceList.CurrentUetsAccount.UetsStatus == "Waiting"){
                    this.waitingProcess = this.uetsPriceList.CurrentUetsAccount.Tariff
                    this.hasWaitingProcess = true
                    if(this.uetsPriceList.CurrentUetsAccount.IsCancelActive == true){
                        this.waitingButton = false;
                    }
                    this.showUetsPanel = false
                } else if(this.uetsPriceList.CurrentUetsAccount.UetsStatus == "Fail"){
                    this.paymentFailed = true
                    this.showUetsPanel = false
                } else if(this.uetsPriceList.CurrentUetsAccount.UetsStatus == "Payment_Success"){
                    this.payment_Success = true;
                    this.showUetsPanel = false
                }
            }
        })

        axios.get("/account/get").then(x => {
            console.log('Summary Result:', x);
            this.data = x.data;
            this.data.Id = '';
        })
        //fatura bilgilerini çeker
        axios.get("/account/getbillinginfo").then(x => {
            if(x.data.Address == null){
                this.invoiceInfo = null;
            }else{
                this.invoiceInfo = x.data;
            }
        })
        //kullanıcının uets kaydı varsa güncel tarife bilgilerini çeker
        axios.get('/uetsAppForm/getuetsaccount').then(x =>{
            this.currentTariff = x.data;
        })
    },
    computed: {
        isUETSAvailable(){
            return (this.hasModule('UETS') && !this.isOnPrem)
        },
        isMultiFactorAuthEnabled(){
            return this.data.Params.IsMultiFactorAuthEnabled;
        },
        availableTabs(){
            var _tabs = this.tabs;

            if(!this.isOnPrem)
                _tabs = _tabs.filter(item => item.key != 'smtp' && item.key != "timestamp" && item.key != 'otp');
            else
                _tabs = _tabs.filter(item => item.key != 'uets');
            if(!this.data.Params.IsMultiFactorAuthEnabled)
                _tabs = _tabs.filter(item => item.key != 'otp');
            if(!(this.hasModule('UETS') && !this.isOnPrem))
                _tabs = _tabs.filter(item => item.key != 'uets');    
             
            return _tabs;
        },
        visibleExternalAccounts()
        {
            return this.data.ExternalAccounts.filter(item => item.ExternalIdentitySource != "LDAP");
        }
    },
    methods: {
        async cancelWaitingProcess(){
            await axios.get('/uetsAppForm/CancelUetsProcess', { params: { id : this.uetsId }})
            location.reload()
            
        },
        getInvoiceInfo(value){
            this.invoiceInfo = value;
            // console.log(this.$root.$data.login.Account.Id)
        },
        firstBuyButtonClicked(){
            if(JSON.stringify(this.additional) === '{}'){
                alert(this.translate('warnings.pleaseFillVKNorDetsis'))
            } else{
                this.paymentTypeFirstTime = true;
                this.isAdditionalRenewalModalVisible = true;
            }
            // console.log(this.additional)
            
        },
        makePayment(){
            var postData = {
                Details : {},
            };
            postData.Kind = "UETS",
            postData.InvoiceInfo = this.invoiceInfo;
            postData.Details.ProductId = this.paymentData.Tariff.id;
            postData.Details.ProductName = this.paymentData.Tariff.name;
            postData.Details.ProductPrice = this.paymentData.Tariff.price.replace(',','.');
            postData.RelatedEntityId = this.RelatedEntityId;
            postData.Status = 0;
            console.log("postData", postData)
            axios.post("/pos/post", postData).then(x => {
                // console.log(x)
                
                if(x.status == 200){
                   var redirectURL = x.data.RedirectUrl;
                   window.location.href = redirectURL; 

                }
            })
           
        },
        changeAdditionalClicked(value){
            this.isAdditionalRenewalModalVisible = false;
            this.paymentTemplateVisible = true;
            var paymentType = "additional";
            this.selectedTariff = value;
            var postData = {};
            postData.MersisNo = this.additional.MersisNo;
            postData.DetsisNo = this.additional.DetsisNo;
            postData.GibNo = this.additional.GibNo;
            postData.Tariff = this.selectedTariff;
            postData.PaymentType = paymentType;
            console.log(postData)
            axios.post('/uetsappForm/post', postData).then(x => {
                // console.log(x);
                this.paymentData = x.data
                if(this.paymentData.Tariff.price == '0'){
                    this.priceZero = true
                }
                this.RelatedEntityId = x.data.Id;
                
            })
        },
        changeAdditionalRenewalClicked(value){
            this.isAdditionalRenewalModalVisible = false;
            this.paymentTemplateVisible = true;
            this.paymentTypeAdditionalRenewal = true;
            this.selectedTariff = value;
            this.paymentTypeRenewal = false;
            var postData = {};
            postData.Tariff = this.selectedTariff;
            postData.PaymentType = "additional_renewal"
            axios.post('/uetsappForm/post', postData).then(x => {
                // console.log(x);
                this.paymentData = x.data
                if(this.paymentData.Tariff.price == '0'){
                    this.priceZero = true
                }
                // console.log("payment data" , this.paymentData)
                this.RelatedEntityId = x.data.Id;
            }).catch(x =>  {
                alert(x.response.data.Message)
            })
        },
        renewalButtonClicked(){
            this.selectedTariff = this.uetsPriceList.CurrentUetsAccount.Tariff
            this.isRenewalModalVisible = false;
            this.paymentTypeRenewal = true;
            this.paymentTypeAdditionalRenewal = false;
            var postData = {}
            postData.PaymentType = "renewal";
            axios.post('/uetsappForm/post', postData).then(x => {
                // console.log(x);
                this.paymentData = x.data
                if(this.paymentData.Tariff.price == '0'){
                    this.priceZero = true
                }
                this.paymentTemplateVisible = true;
                this.RelatedEntityId = x.data.Id;

            })
        },
        
        updateInvoiceInfo(value){
            this.paymentModalVisible = !value;
            this.invoiceInfoVisible = value;
        },
        paymentSuccess(value){
            this.isRenewalModalVisible = !value;
            this.$alert(this.translate('messages.paymentProcessed'),this.translate('messages.success2'),"success");
        },
        uetsPortalRedirect(){
            window.open(window.settings.uetsConfirmUrl, '_blank', 'noreferrer');
        },
        closeRenewalModal(){
            this.isRenewalModalVisible = false;
        },
        closeAdditionalRenewalModal(){
            this.isAdditionalRenewalModalVisible = false;
            this.paymentTypeFirstTime = false;
            //this.selectedTariffList = this.currentTariff.Tariff
        },
        // print(){
        //     var tariff = this.uetsAccountForm.uetsPriceResponse.find(x => x.Id === this.uetsAccountForm.uetsPriceResponse.Id)
        //     this.postData.MersisNo = this.uetsAccountForm.MersisNo
        //     this.postData.DetsisNo = this.uetsAccountForm.DetsisNo
        //     this.postData.VergiNo = this.uetsAccountForm.VergiNo
        //     this.postData.PaymentType = this.uetsAccountForm.PaymentType
        //     this.postData.Tariff = tariff
        //     console.log('UETS Account Form',this.uetsAccountForm)
        //     console.log('Post Data: ', this.postData)
        //     console.log('Selected Tariff: ', tariff)
        //     axios.post('/uetsappForm/post', this.postData).then(x => {
        //         console.log(x)
        //     })

        // },
        save(){
            this.loading = true;
            this.errorMessage = null;
            
            return axios
              .post(`/account/post`, this.data)
              .then(x => {
                console.log("SAVE Result:", x.data);
                this.$root.$data.login.Account.Params = x.data.Params;

                var login = window.localStorage.getItem('user');
                if(login) {
                    login = JSON.parse(login);
                    login.Account.Params = x.data.Params;
                    window.localStorage.setItem("user", JSON.stringify(login));
                }

                this.data = x.data;
                this.loading = false;
                alert(this.translate('messages.accountInfoSaveSuccess'));
                return x;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
                });
        },
        manuelLDAPSyncNow(){
            this.loading = true;
            return axios
                .post(`/account/ManuelSyncLDAPUsers`)
                .then(x => {
                    console.log("Sync Result:", x.data);
                    this.loading = false;
                    alert(x.data.SuccessMessages);
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    this.loading = false;
                });
        }
    }
}
</script>
<style scoped>
    .rbcontent {
        min-height:230px;
    }

    .line-input {
        border: 0;
        border-radius: 0;
        border-bottom: 1px dotted #999;
    }

    .line-input:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
    }
    .invoice-table{
        padding: 20px;
        background-color: white;
        border-radius: 5px;
        box-shadow: 5px 5px 20px rgb(235, 235, 235);
    }
</style>